import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { useEmailVerification } from '../EmailVerificationContext';
import EmailVerificationModals from './EmailVerificationModals';
import EmailLockScreen from './EmailLockScreen';

/** 利用制限・案内を出さないパス（公開ページ・ウィジェット・認証リンク処理・ログイン） */
function isExcludedPath(pathname: string): boolean {
  return (
    pathname.startsWith('/widget') ||
    pathname.startsWith('/cg/') ||
    pathname.startsWith('/sys/auth-action') ||
    pathname.startsWith('/sys/login') ||
    pathname.startsWith('/sys/ncg-apply')
  );
}

/** ロック画面と初回案内モーダルをアプリ全体の上に重ねる（全ルート共通の入口） */
const EmailVerificationOverlay: React.FC = () => {
  const { pathname } = useLocation();
  const { user, isEmbedMode } = useAuth();
  const { phase } = useEmailVerification();

  if (!user || isEmbedMode || isExcludedPath(pathname)) return null;
  if (phase === 'C') return <EmailLockScreen />;
  return <EmailVerificationModals />;
};

export default EmailVerificationOverlay;
